export enum EntityUpdateTypes {
    ORGANIZATION = 'organization',
    RELYING_PARTY = 'relyingParty'
}